import styled from 'styled-components/macro'

import messages from '../../constants/messages'
import { ProductAmounts } from '../../types'
import { AmountItem } from './components/AmountItem/AmountItem'

export function SummaryAmounts({
  productAmounts,
}: {
  productAmounts: ProductAmounts
}) {
  const { totalUnits, totalProducts, totalVariant } = productAmounts

  return (
    <Container>
      <AmountItem
        testId={SummaryAmountsTestIds.TotalUnitsItem}
        valueTestId={SummaryAmountsTestIds.TotalUnitsValue}
        label={messages.totalUnits}
        quantity={totalUnits}
      />
      <AmountItem
        testId={SummaryAmountsTestIds.ProductsItem}
        valueTestId={SummaryAmountsTestIds.ProductsValue}
        label={messages.products}
        quantity={totalProducts}
      />
      <AmountItem
        testId={SummaryAmountsTestIds.ColorsItem}
        valueTestId={SummaryAmountsTestIds.ColorsValue}
        label={messages.colors}
        quantity={totalVariant}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 10px 10px;
  gap: 12px;
`

export const SummaryAmountsTestIds = {
  TotalUnitsItem: 'product-summary-total-units-item',
  TotalUnitsValue: 'product-summary-total-units-value',
  ProductsItem: 'products-summary-products-item',
  ProductsValue: 'products-summary-products-value',
  ColorsItem: 'products-summary-colors-item',
  ColorsValue: 'products-summary-colors-value',
} as const
